// src/components/Header.js
import React, { useMemo } from "react";
import { AppBar, Toolbar, Typography, IconButton } from "@mui/material";
import { Logout } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const Header = React.memo(({ user, onLogout }) => {
  const theme = useTheme();

  // Memoize greeting to prevent recalculation on every render
  const greetingWithEmoji = useMemo(() => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) return "🌅 Good Morning";
    if (currentHour < 18) return "🌞 Good Afternoon";
    return "🌙 Good Evening";
  }, []);

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: theme.palette.primary.main, color: "white" }}
    >
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          {greetingWithEmoji}, {user?.username}
        </Typography>
        <Typography variant="body1" sx={{ marginRight: 2 }}>
          Donor Management System
        </Typography>
        <IconButton color="inherit" onClick={onLogout} title="Logout" aria-label="Logout" data-log="Logout Button">
          <Logout />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
});

export default Header;
